import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Votify.css";
import { Button } from "semantic-ui-react";

import TrackQueue from "../VotifyQueue/TrackQueue";
import VotifyPartyHeader from "../VotifyPlayback/VotifyPartyHeader";
import MainTopMenu from "./MainTopMenu";
import VotifyMessages from "./VotifyMessages";

class VotifyComponent extends Component {
  constructor(props) {
    super(props);

    this.initializePlayback = this.initializePlayback.bind(this);
  }

  initializePlayback() {
    this.props.initializePlayback();
  }

  render() {
    const { isHost, isInitialized } = this.props;
    return (
      <div className="Votify">
        <MainTopMenu {...this.props} />
        <VotifyPartyHeader />
        {isHost && !isInitialized && (
          <Button
            basic
            positive
            content={"Start playing"}
            style={{ margin: "0.25rem" }}
            onClick={this.initializePlayback}
          />
        )}
        <VotifyMessages />
        <TrackQueue />
      </div>
    );
  }
}

VotifyComponent.propTypes = {
  initializePlayback: PropTypes.func.isRequired,
  isHost: PropTypes.bool.isRequired,
  isInitialized: PropTypes.bool.isRequired,
  partyUrl: PropTypes.string,
};

export default VotifyComponent;
